import React from 'react';
import { AdfNodeProps } from './AdfModelTypes';

export const AdfDate = React.memo(({ node }: AdfNodeProps) => {
    const timestamp = node.attrs?.timestamp;
    if (!timestamp) return <span>Invalid date</span>;

    const date = new Date(parseInt(timestamp));
    const formattedDate = date.toLocaleDateString();

    return <span className="date">{formattedDate}</span>;
});
